/*
 * @Description: 企点产品订单
 * @Author: 杨志航
 * @Date: 2026-05-27 11:25:07
 */
import React, { useEffect, useState } from 'react'
import {
  Input,
  InputNumber,
  Form,
  Row,
  Col,
  Select
} from 'antd'
import api from '@/api'

const FormItem = Form.Item
const { Option } = Select

const CompanyPoint = props => {
  const { oaidObj, accountObj, detail, mediaList, contractData, form } = props
  const { getFieldDecorator, setFieldsValue } = form
  const [productList1, setProductList1] = useState([])
  const [productList2, setProductList2] = useState([])

  const selectProject = (index, val) => {
    api.getsysProjectChilds({ pid: val }).then(data => {
      if (index === 1) {
        setProductList1(data)
        setFieldsValue({ product1: undefined })
      } else {
        setProductList2(data)
        setFieldsValue({ product2: undefined })
      }
    })
  }

  useEffect(() => {
    if (contractData.project1) {
      api.getsysProjectChilds({ pid: contractData.project1.split('|')[0] }).then(data => {
        setProductList1(data)
      })
      api.getsysProjectChilds({ pid: contractData.project2.split('|')[0] }).then(data => {
        setProductList2(data)
      })
    }
  }, [contractData])

  return (
    <>
      <div className="line"></div>
      <h3 className="apply-tit">双方公司信息</h3>
      <div className="underline"></div>
      <Row gutter={24}>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>甲方（委托方）</div>
        </Col>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333'}}>乙方（服务提供方）</div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{oaidObj.name ? oaidObj.name : detail.partA}</div>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="名称" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            <div>{accountObj.fullName ? accountObj.fullName : detail.partB}</div>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系人" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('contactA', {
              rules: [{ required: true, message: '请输入甲方联系人' }]
            })(<Input placeholder="请输入甲方联系人" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="联系方式" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('mobileA', {
              rules: [{ required: true, message: '请输入甲方联系电话' }]
            })(<Input placeholder="请输入甲方联系电话" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
        </Col>
      </Row>
      <div className="line"></div>
      <h3 className="apply-tit" style={{ marginTop: '40px' }}>产品信息与订阅期间</h3>
      <div className="underline" style={{ marginBottom: '16px' }}></div>
      <Row gutter={24}>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333', fontSize: '16px'}}>产品信息1</div>
        </Col>
        <Col span={11} offset={1}>
          <div style={{padding: '20px', color: '#333333', fontSize: '16px'}}>产品信息2</div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="投放媒体" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('project1', {
              rules: [{ required: true, message: '请选择' }],
            })(
              <Select
                placeholder="请选择"
                dropdownMatchSelectWidth={false}
                showSearch
                optionFilterProp="children"
                style={{ width: 240 }}
                onChange={val => selectProject(1, val)}
              >
                {mediaList.map((item, index) => (
                  <Option
                    key={index}
                    value={`${item.id}|${item.name}`}
                  >
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="投放媒体" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('project2', {
              rules: [{ required: true, message: '请选择' }],
            })(
              <Select
                placeholder="请选择"
                dropdownMatchSelectWidth={false}
                showSearch
                optionFilterProp="children"
                style={{ width: 240 }}
                onChange={val => selectProject(2, val)}
              >
                {mediaList.map((item, index) => (
                  <Option
                    key={index}
                    value={`${item.id}|${item.name}`}
                  >
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="产品" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('product1', {
              rules: [{ required: true, message: '请选择' }],
            })(
              <Select
                placeholder="请选择"
                dropdownMatchSelectWidth={false}
                showSearch
                optionFilterProp="children"
                style={{ width: 240 }}
              >
                {productList1.map((item, index) => (
                  <Option
                    key={index}
                    value={`${item.id}|${item.name}`}
                  >
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="产品" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('product2', {
              rules: [{ required: true, message: '请选择' }],
            })(
              <Select
                placeholder="请选择"
                dropdownMatchSelectWidth={false}
                showSearch
                optionFilterProp="children"
                style={{ width: 240 }}
              >
                {productList2.map((item, index) => (
                  <Option
                    key={index}
                    value={`${item.id}|${item.name}`}
                  >
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="订阅类型" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('subscriptionType1', {
              rules: [{ required: true, message: '请输入订阅类型' }]
            })(<Input placeholder="请输入订阅类型" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="订阅类型" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('subscriptionType2', {
              rules: [{ required: true, message: '请输入订阅类型' }]
            })(<Input placeholder="请输入订阅类型" style={{ width: 240 }} />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="工号数量" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('workNumber1', {
              rules: [{ required: true, message: '请输入工号数量' }]
            })(<InputNumber 
              placeholder="请输入工号数量（或应用个数）" 
              style={{ width: 240 }} 
              precision={0}
              step={1}
              min={0}
            />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="工号数量" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('workNumber2', {
              rules: [{ required: true, message: '请输入工号数量' }]
            })(<InputNumber 
              placeholder="请输入工号数量（或应用个数）" 
              style={{ width: 240 }} 
              precision={0}
              step={1}
              min={0}
            />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <FormItem label="价格" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('price1', {
              rules: [{ required: true, message: '请输入价格' }]
            })(<InputNumber 
              placeholder="请输入价格" 
              style={{ width: 240 }}
              precision={2}
              step={0.01}
              min={0}
            />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="价格" labelCol={{ span: 4 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('price2', {
              rules: [{ required: true, message: '请输入价格' }]
            })(<InputNumber 
              placeholder="请输入价格" 
              style={{ width: 240 }} 
              precision={2}
              step={0.01}
              min={0}
            />)}
          </FormItem>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <FormItem label="订阅期间" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
            {getFieldDecorator('subscriptionPeriod', {
              rules: [{ required: true, message: '请输入订阅期间' }]
            })(<Input.TextArea placeholder="请输入订阅期间" rows={4} />)}
          </FormItem>
        </Col>
      </Row>
    </>
  )
}

export default CompanyPoint